// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { MergeTemplate } from './merge-template';
import { ReplaceField } from './replace-field';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MergeTemplateReplaceField extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  mergeTemplateId!: number;
  replaceFieldId!: number;
  ts?: string;
  mergeTemplate!: MergeTemplate;
  replaceField!: ReplaceField;
}

